var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('FilterJobLibraries', {
    attrs: {
      "showModalFilter": _vm.showModalFilter,
      "filters": _vm.jobLibraries.params,
      "tab": "all"
    },
    on: {
      "close": function close($event) {
        _vm.showModalFilter = false;
      },
      "apply-filter": _vm.fetchData
    }
  }), _c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit"
    },
    on: {
      "ok": _vm.handleImport
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModalImport = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModalImport,
      callback: function callback($$v) {
        _vm.showModalImport = $$v;
      },
      expression: "showModalImport"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")])]], 2), _c('b-modal', {
    attrs: {
      "title": "Import Result",
      "size": "xl",
      "hide-footer": ""
    },
    model: {
      value: _vm.modalResponseImport,
      callback: function callback($$v) {
        _vm.modalResponseImport = $$v;
      },
      expression: "modalResponseImport"
    }
  }, [_c('ImportResultRh', {
    attrs: {
      "response": _vm.dataResponseImport,
      "errorFields": _vm.errorFieldImport,
      "successFields": _vm.successFieldImport
    }
  })], 1), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Engine List",
      "size": "lg"
    },
    model: {
      value: _vm.modalEngine.show,
      callback: function callback($$v) {
        _vm.$set(_vm.modalEngine, "show", $$v);
      },
      expression: "modalEngine.show"
    }
  }, [_vm.modalEngine.data ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('th', [_vm._v("Engine Name")]), _c('th', [_vm._v("Engine Type")]), _c('th', [_vm._v("Interval")])]), _c('tbody', _vm._l(_vm.modalEngine.data, function (engine) {
    var _engine$power_series, _engine$power_series2, _engine$power_type;
    return _c('tr', {
      key: engine.id
    }, [_c('td', [_vm._v(" " + _vm._s(engine === null || engine === void 0 ? void 0 : (_engine$power_series = engine.power_series) === null || _engine$power_series === void 0 ? void 0 : _engine$power_series.name) + " "), _c('br'), _c('small', [_vm._v(_vm._s(engine === null || engine === void 0 ? void 0 : (_engine$power_series2 = engine.power_series) === null || _engine$power_series2 === void 0 ? void 0 : _engine$power_series2.model))])]), _c('td', [_vm._v(_vm._s((engine === null || engine === void 0 ? void 0 : (_engine$power_type = engine.power_type) === null || _engine$power_type === void 0 ? void 0 : _engine$power_type.name) || '-'))]), _c('td', [_vm._v(_vm._s(_vm.formatNumber(engine === null || engine === void 0 ? void 0 : engine.interval_hour)) + " Hours")])]);
  }), 0)]) : _vm._e()]), _vm.modalFleet.show ? [_c('SelectFleetJobLibrary', {
    attrs: {
      "isOpen": _vm.modalFleet.show,
      "jobLibraryIds": _vm.selectedJobIds,
      "isPreview": _vm.modalFleet.isPreview,
      "fleetsSelected": _vm.modalFleet.fleetSelecteds,
      "title": _vm.modalFleet.isPreview ? 'Fleets Assigned' : 'Select Fleets'
    },
    on: {
      "close": _vm.handleCloseModalFleet,
      "next": _vm.onSelectedFleets
    }
  })] : _vm._e(), _c('custom-sidebar', {
    attrs: {
      "size": "50%",
      "title": _vm.sidebar.title
    },
    model: {
      value: _vm.sidebar.show,
      callback: function callback($$v) {
        _vm.$set(_vm.sidebar, "show", $$v);
      },
      expression: "sidebar.show"
    }
  }, [_vm.sidebar.show ? [_vm.sidebar.title == 'New Job Library' ? [_c('FormJobLibraries', {
    attrs: {
      "selectedData": _vm.jobLibraries.detailData
    },
    on: {
      "close": _vm.closeSidebar,
      "refetch": function refetch($event) {
        return _vm.fetchData();
      }
    }
  })] : _vm.sidebar.title == 'Edit Job Library' ? [_c('FormJobLibraries', {
    attrs: {
      "selectedData": _vm.jobLibraries.detailData
    },
    on: {
      "close": _vm.closeSidebar,
      "refetch": function refetch($event) {
        return _vm.fetchData();
      }
    }
  })] : [_c('DetailJobLibraries', {
    attrs: {
      "selectedData": _vm.jobLibraries.detailData
    }
  })]] : _vm._e()], 2), _c('CustomSidebar', {
    attrs: {
      "size": "100%",
      "title": "Assign Job Library To Fleet"
    },
    model: {
      value: _vm.sidebarAssign,
      callback: function callback($$v) {
        _vm.sidebarAssign = $$v;
      },
      expression: "sidebarAssign"
    }
  }, [_vm.sidebarAssign ? [_c('FormAssignFleets', {
    attrs: {
      "selectedFleets": _vm.selectedFleets
    },
    on: {
      "close": function close($event) {
        _vm.sidebarAssign = false;
      },
      "refetch": _vm.fetchData
    }
  })] : _vm._e()], 2), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [[_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex mb-3"
  }, [_c('div', {
    staticClass: "mr-2"
  }, [_c('b-form-input', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    model: {
      value: _vm.jobLibraries.params.search,
      callback: function callback($$v) {
        _vm.$set(_vm.jobLibraries.params, "search", $$v);
      },
      expression: "jobLibraries.params.search"
    }
  })], 1), _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.showModalFilter = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sliders"
  }), _vm._v(" Filter Data ")])], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('ImportAssignJobToFleetModal', {
    attrs: {
      "refetch": _vm.fetchData
    }
  }), _c('b-button', {
    staticClass: "d-flex align-items-center mx-2",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.showModalImport = true;
      }
    }
  }, [_c('i', {
    staticClass: "ri-upload-2-line pl-1"
  }), _vm._v(" Import ")]), _c('b-button', {
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.openSidebar();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-2"
  }), _vm._v(" New Data ")]), _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "disabled": _vm.selectedJobIds.length === 0,
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.openModalAssign();
      }
    }
  }, [_vm._v(" Assign to Fleets ")])], 1)]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_c('b-form-checkbox', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "checked": _vm.isCheckedAll
    },
    on: {
      "change": _vm.toggleSelectAll
    }
  })], 1), _c('th', [_vm._v("Job Name")]), _c('th', [_vm._v("Equipment / Category")]), _c('th', [_vm._v("Assigned")]), _c('th', [_vm._v("Job Type / Class")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Interval")]), _c('th', [_vm._v("Engine Name")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])]), _c('tbody', _vm._l(_vm.jobLibraries.data, function (item, index) {
    var _item$maintenance_job, _item$maintenance_job2, _item$maintenance_job3, _item$maintenance_job4, _item$calendar_interv, _item$calendar_type, _item$job_library_cou;
    return _c('tr', {
      key: index
    }, [_c('td', [_c('b-form-checkbox', {
      staticClass: "d-flex justify-content-center",
      attrs: {
        "type": "checkbox",
        "value": item.id
      },
      model: {
        value: _vm.selectedJobIds,
        callback: function callback($$v) {
          _vm.selectedJobIds = $$v;
        },
        expression: "selectedJobIds"
      }
    })], 1), _c('td', [_vm._v(_vm._s(item.name))]), _c('td', [_c('strong', {
      staticClass: "text-primary"
    }, [_vm._v(" " + _vm._s(item.maintenance_master.equipment_name) + " ")]), _c('br'), _c('small', [_vm._v(_vm._s(item.maintenance_component.component_name))])]), _c('td', [_c('span', {
      staticClass: "cursor-pointer text-primary fw-bold",
      on: {
        "click": function click($event) {
          return _vm.handleClickPreviewFleet(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.assigned) + " Fleet ")])]), _c('td', [_c('strong', {
      staticClass: "text-black"
    }, [_vm._v(" " + _vm._s((_item$maintenance_job = (_item$maintenance_job2 = item.maintenance_job_type) === null || _item$maintenance_job2 === void 0 ? void 0 : _item$maintenance_job2.description) !== null && _item$maintenance_job !== void 0 ? _item$maintenance_job : '-') + " ")]), _c('br'), _c('small', [_vm._v(" " + _vm._s((_item$maintenance_job3 = (_item$maintenance_job4 = item.maintenance_job_class) === null || _item$maintenance_job4 === void 0 ? void 0 : _item$maintenance_job4.job_class) !== null && _item$maintenance_job3 !== void 0 ? _item$maintenance_job3 : '-') + " ")])]), _c('td', {
      staticClass: "text-nowrap",
      attrs: {
        "align": "center"
      }
    }, [item.method == 'CALENDAR' ? _c('span', [_vm._v(" " + _vm._s((_item$calendar_interv = item.calendar_interval) !== null && _item$calendar_interv !== void 0 ? _item$calendar_interv : '-') + " " + _vm._s((_item$calendar_type = item.calendar_type) !== null && _item$calendar_type !== void 0 ? _item$calendar_type : '') + " ")]) : _vm._e(), _c('br'), _c('small', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.method))])]), _c('td', {
      staticClass: "text-center"
    }, [(_item$job_library_cou = item.job_library_counters) !== null && _item$job_library_cou !== void 0 && _item$job_library_cou.length ? _c('b-button', {
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          _vm.modalEngine.show = true;
          _vm.modalEngine.data = item.job_library_counters;
        }
      }
    }, [_vm._v(" Engine List ")]) : [_vm._v("-")]], 2), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('b-dropdown', {
      attrs: {
        "size": "sm",
        "variant": "outline-primary",
        "text": "Action",
        "right": ""
      }
    }, [_c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.openSidebar(item);
        }
      }
    }, [_vm._v(" Edit ")]), _c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.openSidebar(item, true);
        }
      }
    }, [_vm._v(" Detail ")]), _c('b-dropdown-item', {
      staticClass: "text-danger",
      attrs: {
        "disabled": item.assigned > 0
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.deleteItem(item);
        }
      }
    }, [_vm._v(" Delete ")])], 1)], 1)]);
  }), 0)]), _c('div', {
    staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
  }, [_c('b-pagination', {
    staticClass: "mb-0 mr-3",
    attrs: {
      "total-rows": _vm.jobLibraries.params.total,
      "per-page": _vm.jobLibraries.params.limit,
      "first-number": "",
      "align": "center"
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: _vm.jobLibraries.params.page,
      callback: function callback($$v) {
        _vm.$set(_vm.jobLibraries.params, "page", $$v);
      },
      expression: "jobLibraries.params.page"
    }
  }), _c('b-form-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "plain": "",
      "options": _vm.limitOptions
    },
    on: {
      "input": function input() {
        return _vm.fetchData();
      }
    },
    model: {
      value: _vm.jobLibraries.params.limit,
      callback: function callback($$v) {
        _vm.$set(_vm.jobLibraries.params, "limit", $$v);
      },
      expression: "jobLibraries.params.limit"
    }
  })], 1)])]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }